// extracted by mini-css-extract-plugin
export default {"team":"AboutTeam_team__LBm48","container":"AboutTeam_container__WEWwf","intro":"AboutTeam_intro__0Vu2g","teams":"AboutTeam_teams__I26ct"};